import gql from 'graphql-tag'

export const GetPatientMedications = gql`
  query GetPatientMedications($organizationId: ID, $patientId: ID!, $appointmentId: ID) {
    patientMedications(input: {
      organizationId: $organizationId
      patientId: $patientId
      appointmentId: $appointmentId
    }) {
      patientId
      medications {
        id
        emrMedicationName
        medicationStructuredSig {
          dosage
          dosageUnit
          route
          frequency
        }
        unstructuredSig
      }
    }
  }
`

export const SyncChartsData = gql`
  mutation SyncChartsData($sukiPatientId: ID!, $emrPatientId: ID, $emrAppointmentDepartmentId: ID, $emrEncounterId: ID, $sukiAppointmentId: ID) {
    syncChartsData(input: {
      sukiPatientId: $sukiPatientId
      emrPatientId: $emrPatientId,
      emrAppointmentDepartmentId: $emrAppointmentDepartmentId,
      emrEncounterId: $emrEncounterId,
      sukiAppointmentId: $sukiAppointmentId
    }) {
      numActiveProblemsSyncd
      numInactiveProblemsSyncd
      numEncounterDiagnosesSyncd
    }
  }
`
